import { ForwardedRef, forwardRef, ReactNode } from 'react';
import ReactSlick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface SliderProps {
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

const settings = {
  dots: false,
  speed: 400,
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: false,
};

const Slider = forwardRef(
  ({ children, className, ariaLabel }: SliderProps, ref: ForwardedRef<ReactSlick>) => (
    <ReactSlick {...settings} className={className} aria-label={ariaLabel} ref={ref}>
      {children}
    </ReactSlick>
  )
);

export default Slider;
